import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {Interlignage, PoliceNames, style, ThemesNames} from "../../common/models/style.model";
import {StyleService} from "../../common/services/style.service";
import {UntypedFormBuilder, UntypedFormGroup} from "@angular/forms";

@Component({
  selector: 'app-accessibility',
  templateUrl: './accessibility.component.html',
  styleUrls: ['./accessibility.component.scss']
})
export class AccessibilityComponent implements OnInit {
  mainStyle: style = <style>{};
  interlignage: Interlignage = Interlignage.default;
  interlignages = Interlignage;
  police: PoliceNames = PoliceNames.default;
  policeNames = PoliceNames;
  themesNames = ThemesNames;
  accessibilityForm: UntypedFormGroup;
  constructor(@Inject(MAT_DIALOG_DATA) public data: {mainStyle: style, interlignage: Interlignage, police: PoliceNames},
              public dialogRef: MatDialogRef<AccessibilityComponent>,
              private styleService: StyleService,
              private formBuilder: UntypedFormBuilder,) { }

  ngOnInit(): void {
    this.mainStyle = this.data.mainStyle;
    this.interlignage = this.data.interlignage;
    this.police = this.data.police;
    this._initForm();
  }

  setTheme(themeName: ThemesNames): void {
    this.styleService.updateMainBGColor(themeName);
    this.styleService.mainStyle$.subscribe((_mainStyle)=> {
      this.mainStyle = _mainStyle;
    });
  }

  setPolice(police: PoliceNames): void {
    this.styleService.updateMainpolice(police);
    this.styleService.police$.subscribe((_police)=> {
      this.police = _police;
    });
  }

  setInterlignage(interlignage: Interlignage): void {
    this.styleService.updateMainInterlignage(interlignage);
    this.styleService.interlignage$.subscribe((_interlignage)=> {
      this.interlignage = _interlignage;
    });
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  private _initForm(): void {
    this.accessibilityForm = this.formBuilder.group({
      theme: [this.mainStyle.themeName, []],
      police: [this.police, []],
      interlignage: [this.interlignage, []],
    });
  }

  getThemeName(themeName: string): string{
    return this.styleService.getThemeName(themeName);
  }

}
